import Api from './Api';
import Configuracao from '../util/Configuracao';

class AcertoCoparticipacaoApi extends Api {
  async consultarTodosOsProtocolos () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosProtocolosAcertoCoparticipacao;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTipos () {
    try {
      const tiposUrl = Configuracao.getConfiguracao().urlConsultarTiposAcertoCoparticipacao;
      const response = await this.fetch(tiposUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEstados () {
    try {
      const estadosAcertoUrl = Configuracao.getConfiguracao().urlConsultarEstadosAcertoCoparticipacao;
      const response = await this.fetch(estadosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuias (numMatricula) {
    try {
      const guiasAcertoUrl = Configuracao.getConfiguracao().guiasAcertoUrl + numMatricula;
      const response = await this.fetch(guiasAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiasCarteiraPrestador (numMatricula, seqPrestador) {
    try {
      const guiasAcertoUrl = Configuracao.getConfiguracao().guiasAcertoUrl + numMatricula +
      '/prestador/' + seqPrestador;
      const response = await this.fetch(guiasAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativos (numMatricula) {
    try {
      const demonstrativosAcertoUrl = Configuracao.getConfiguracao().demonstrativosAcertoUrl + numMatricula;
      const response = await this.fetch(demonstrativosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarAcertos (numProtocolo, numMatricula, codOrigem, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal, seqPrestador) {
    try {
      const acertoUrl = Configuracao.getConfiguracao().urlConsultarAcertosCoparticipacao +
      numProtocolo + '/' +
      numMatricula + '/' +
      codOrigem + '/' +
      codEstado + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal + '/' +
      seqPrestador;
      const response = await this.fetch(acertoUrl, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProcedimentosPagAntecipado (numMatricula, seqProcedimentosSelecionados) {
    try {
      const urlConsultarProcedimentosPagAntecipado = Configuracao.getConfiguracao().urlConsultarProcedimentosPagAntecipado +
      numMatricula;
      const response = await this.fetch(urlConsultarProcedimentosPagAntecipado, 'post', seqProcedimentosSelecionados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProcedimentos (numProtocolo) {
    try {
      const urlConsultarProcedimentos = Configuracao.getConfiguracao().urlConsultarProcedimentos +
      numProtocolo;
      const response = await this.fetch(urlConsultarProcedimentos, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProcedimentosCopartCalcIncorreto (numMatricula, codGuia, numDemonstrativo, seqPrestador, seqProcedimentosSelecionados) {
    try {
      const urlConsultarProcedimentosCopartCalcIncorreto = Configuracao.getConfiguracao().urlConsultarProcedimentosCopartCalcIncorreto +
        numMatricula + '/' +
        codGuia + '/' +
        numDemonstrativo + '/' +
        seqPrestador;
      const response = await this.fetch(urlConsultarProcedimentosCopartCalcIncorreto, 'post', seqProcedimentosSelecionados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProcedimentosDevolucao (numMatricula, codGuia, seqProcedimentosSelecionados) {
    try {
      const urlConsultarProcedimentosDevolucao = Configuracao.getConfiguracao().urlConsultarProcedimentosDevolucao +
        numMatricula + '/' +
        codGuia;
      const response = await this.fetch(urlConsultarProcedimentosDevolucao, 'post', seqProcedimentosSelecionados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirAcerto (acerto) {
    try {
      const urlIncluirAcerto = Configuracao.getConfiguracao().urlIncluirAcertoCoparticipacao;
      const response = await this.fetch(urlIncluirAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  async alterarAcerto (acerto) {
    try {
      const urlAlterarAcerto = Configuracao.getConfiguracao().urlAlterarAcertoCoparticipacao;
      const response = await this.fetch(urlAlterarAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    try {
      const urlCancelarAcerto = Configuracao.getConfiguracao().urlCancelarAcertoCopart + numProtocolo + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoPagAntecipado (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = Configuracao.getConfiguracao().urlProcessarAcertoPagAntecipado +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoDevolucao (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = Configuracao.getConfiguracao().urlProcessarAcertoDevolucao +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoCobrancaIndevida (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = Configuracao.getConfiguracao().urlProcessarAcertoCobrancaIndevida +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    try {
      const urlDesfazerCancelamentoAcerto = Configuracao.getConfiguracao().urlDesfazerCancelamentoAcertoCopart + numProtocolo;
      const response = await this.fetch(urlDesfazerCancelamentoAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcerto (numProtocolo) {
    try {
      const urlExcluirAcerto = Configuracao.getConfiguracao().urlExcluirAcertoCoparticipacao + numProtocolo;
      const response = await this.fetch(urlExcluirAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async anexarArquivo (numProtocolo, nomeArquivo, txtObjetoGed) {
    try {
      const urlAnexarArquivo = Configuracao.getConfiguracao().urlAnexarArquivo + numProtocolo + '/' + nomeArquivo + '/' + txtObjetoGed;
      const response = await this.fetch(urlAnexarArquivo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (numProtocolo) {
    try {
      const consultarArquivosUrl = Configuracao.getConfiguracao().consultarArquivosUrl + numProtocolo;
      const response = await this.fetch(consultarArquivosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codArquivo) {
    try {
      const urlDeletarArquivo = Configuracao.getConfiguracao().urlDeletarArquivo + codArquivo;
      const response = await this.fetch(urlDeletarArquivo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AcertoCoparticipacaoApi;
